import { BoxPlotFilled, DeleteFilled } from '@ant-design/icons'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Col, Popconfirm, Row } from 'antd'
import React, { useState } from 'react'

import { handleRemove } from './helpers'

export function BulkChangeBar({ selectedRows, setIsBulkChangeVisible, refetch }) {
  const [loading, setLoading] = useState()
  if (selectedRows.length > 0) {
    return (
      <Horizontal bg='primary' className='p-3'>
        <Col className='title vertical-flex-center px-3' span={16} align='left'>
          <Texto className='tank-override-count-text'>
            <b>
              {selectedRows.length} tank{selectedRows.length > 1 ? 's' : ''} selected to override.
            </b>{' '}
            You can bulk remove the overrides - or bulk change values here.
          </Texto>
        </Col>

        <Col span={8} className='flex items-center h-100 py-3 justify-end'>
          <div className='tank-override-button'>
            <Popconfirm
              title='Are you sure you want to delete the selected overrides?'
              onConfirm={() => {
                handleRemove(selectedRows, refetch, setLoading)
              }}
              okText='Yes'
              cancelText='No'
            >
              <GraviButton
                error
                loading={loading}
                className='mr-3 bright-theme-error'
                buttonText='Remove Selected Overrides'
                icon={<DeleteFilled />}
                disabled={!selectedRows?.some((row) => row.is_overridden)}
              />
            </Popconfirm>
            <GraviButton
              theme2
              ghost
              appearance='outline'
              buttonText='Bulk Change Strategies'
              onClick={() => setIsBulkChangeVisible(true)}
              className='mr-3 bright-theme-2'
              icon={<BoxPlotFilled />}
            />
          </div>
        </Col>
      </Horizontal>
    )
  }
  const { scopes } = useSecurityContext()
  const canEdit = scopes.admin?.site_write
  return (
    <div className='bg-3 p-4'>
      {canEdit && (
        <Texto category='h5' weight='bold' appearance='secondary'>
          Select tank(s) to override
        </Texto>
      )}
    </div>
  )
}
